export default {
  activeProjectId: null,
  activeProject: null,     // opcional: payload completo do getActive
  defaultProjectName: 'Novo projeto',
  layers: [],
  uploadLayers: [],
  options: null,           // zoom, center etc
  status: 'idle',          // idle | loading | ready | error
  error: null
}
